import { render, staticRenderFns } from "./ModuleSelectModal.vue?vue&type=template&id=c99ec2f6&scoped=true&"
import script from "./ModuleSelectModal.vue?vue&type=script&lang=ts&"
export * from "./ModuleSelectModal.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleSelectModal.vue?vue&type=style&index=0&id=c99ec2f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99ec2f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c99ec2f6')) {
      api.createRecord('c99ec2f6', component.options)
    } else {
      api.reload('c99ec2f6', component.options)
    }
    module.hot.accept("./ModuleSelectModal.vue?vue&type=template&id=c99ec2f6&scoped=true&", function () {
      api.rerender('c99ec2f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModuleSelectModal.vue"
export default component.exports